import { SubmissionError } from 'redux-form';
import fetch from '../../utils/fetch';

export function error(error) {
  return {
    type: 'DELIVERY_CHANGE_ERROR', error,
  };
}

export function loading(loading) {
  return {
    type: 'DELIVERY_CHANGE_LOADING', loading,
  };
}

export function success(changed) {
  return {
    type: 'DELIVERY_CHANGE_SUCCESS', changed,
  };
}

export function change(route, method) {
  return (dispatch) => {
    dispatch(loading(route));

    setTimeout(() => fetch(route, {
      method,
      body: JSON.stringify({}),
    })
      .then((response) => {
        dispatch(loading(false));

        return response.json();
      })
      .then((data) => {
        dispatch(success(data));
      })
      .catch((e) => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      }), 2000);
  };
}

export function reset() {
  return {
    type: 'DELIVERY_CHANGE_RESET',
  };
}
